<template>
    <v-dialog v-model="exibirModal" :max-width="Modal.Confirmacao.larguraMaxima" persistent>
        <v-card :min-width="Modal.Confirmacao.larguraMinima" :max-width="Modal.Confirmacao.larguraMaxima">
            <v-card-title class="primary modal-title py-0" primary-title>
                <span>Opções do Download</span>
                <v-spacer></v-spacer>
                <v-btn icon small flat color="white" @click="$emit('fechar')">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="lista-opcoes">
                <az-call-to-action
                    v-for="(item, index) in opcoesAtivas"
                    :key="index"
                    :value="item"
                    @click="emitirEventoSelecionarOpcao(item.valor)"
                    class="botao-opcao mx-2">
                  {{ item.label }}
                </az-call-to-action>
            </v-card-text>

            <v-card-actions class="px-3 py-2">
                <v-btn id="botaoFechar" @click="$emit('fechar')" color="botao-cancelar-color" flat outline>
                    CANCELAR
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {Modal, opcoesDownload} from '@/core/constants'

export default {
    name: 'ModalOpcoesDownload',
    props: ['exibirModal', 'assinado'],
    data(){
        return {
            opcoesDownload,
            Modal
        }
    },
    methods:{
        emitirEventoSelecionarOpcao(tipo){
            this.$emit('selecionarOpcao', tipo)
        }
    },
    computed:{
        opcoesAtivas(){
            if(!this.assinado){
                return opcoesDownload.tiposDownload.filter(tipo => tipo.valor !== 'ASSINADO')
            }
            else{
                return opcoesDownload.tiposDownload
            }
        }
    },
}
</script>

<style scoped lang="stylus">
    .lista-opcoes
        text-align center

        &__acao
            text-align center
            margin-bottom 16px

            .botao
                color #777 !important
                border 0

            .botao:first-child
                margin-right 10px

            .botao-primario, .botao
                text-transform uppercase
                font-size 13px


    .botao-desativado
        color #777 !important

</style>
